import SettingsPanel from '../../components/shikky/components/SettingsPanel';

const PanelSettings = ({ settings, user }) => {
  return <SettingsPanel settings={settings} />;
};

export default PanelSettings;
